import { render } from "./DriverNavbar.vue?vue&type=template&id=7bc5a2d0"
import script from "./DriverNavbar.vue?vue&type=script&lang=js"
export * from "./DriverNavbar.vue?vue&type=script&lang=js"
script.render = render

export default script